export default __webpack_public_path__ + "static/media/arrow-black-left.c3157772.png";